

const findAnswersWithParentAnswerId = (parentAnswerId: string, allChecklistAnswers: any, allQuestionAnswersForCheckPeriod: any) => {
  const answersWithParentAnswerId: any[] = []
  for (const answerId in allChecklistAnswers) {
    const thisAnswer = allChecklistAnswers[answerId]
    if (thisAnswer.ParentAnswerId === parentAnswerId) {
      answersWithParentAnswerId.push(thisAnswer)
    }
  }
  return answersWithParentAnswerId
}

function sort_chcecklist_answers(checklistAnswers: any, questionId: string, checkPeriodId: string) {
  if (!checklistAnswers) {
    return [];
  }

  // Convert the object into an array of [key, value] pairs
  const entries = Object.entries(checklistAnswers);

  // Sort based on repeatAnswerAfter.number, defaulting to 0
  const sortedEntries = entries.sort(([, aVal], [, bVal]) => {
    //@ts-ignore
    const aNum = aVal?.repeatAnswerAfter?.number ?? 0;
    //@ts-ignore
    const bNum = bVal?.repeatAnswerAfter?.number ?? 0;
    return aNum - bNum;
  });

  // Convert sorted entries back into an object
  const sortedChecklistAnswers = Object.fromEntries(sortedEntries);

  // Uncomment for debugging
  // console.log(`sorted checklist answers: ${JSON.stringify(sortedChecklistAnswers)}`);
  const keys = Object.keys(sortedChecklistAnswers)
  return keys
}


const appendAnswers = (question: ObjectStringKeyAnyValue, tableData: ObjectStringKeyAnyValue, allQuestionAnswersForCheckPeriod: any, checkPeriodId: string) => {
  //console.log('⏰⏰')
  const nonRepeatAnswers: any[] = []
  const repeatAnswers: any[] = []
  const sortedChecklistAnswerIds: any[] = sort_chcecklist_answers(tableData.ChecklistAnswers, question.Id, checkPeriodId)
  for (const answerId of sortedChecklistAnswerIds
  ) {
    const thisAnswer = tableData.ChecklistAnswers[answerId]
    if (thisAnswer && 
      thisAnswer.QuestionId === question.Id
      && thisAnswer.ChecklistPeriodId === checkPeriodId
      && !thisAnswer.ParentAnswerId
    ) {
      if (thisAnswer.repeatAnswerAfter) {
        repeatAnswers.push(thisAnswer)
        let child_answers_for_this_answer = findAnswersWithParentAnswerId(thisAnswer.Id, tableData.ChecklistAnswers, allQuestionAnswersForCheckPeriod)
        child_answers_for_this_answer.forEach((childAnswer: any) => {
          repeatAnswers.push(childAnswer)
        })
      } else {
        nonRepeatAnswers.push(thisAnswer)
        let child_answers_for_this_answer = findAnswersWithParentAnswerId(thisAnswer.Id, tableData.ChecklistAnswers, allQuestionAnswersForCheckPeriod)
        child_answers_for_this_answer.forEach((childAnswer: any) => {
          nonRepeatAnswers.push(childAnswer)
        })
      }
    }
  }

  // repeatAnswers.sort((b, a) => { 
  //   console.log(`sorting ${a} and ${b}`) 
  //   return parseInt(a.repeatAnswerAfter && a.repeatAnswerAfter.number) - parseInt(b.repeatAnswerAfter && b.repeatAnswerAfter.number) }

  // )
  nonRepeatAnswers.forEach((answer: any) => { allQuestionAnswersForCheckPeriod.push(answer) })
  repeatAnswers.forEach((answer: any) => { allQuestionAnswersForCheckPeriod.push(answer) })
}

export const sortAllQuestionAnswersForCheckPeriod = (checkPeriodId: string, tableData: ObjectStringKeyAnyValue) => {
  let allQuestionAnswersForCheckPeriod: any = []
  //console.log(`sorting all questions: ${tableData.ChecklistQuestions ? tableData.ChecklistQuestions.length : 0} questions`)

  // find all questions which are NOT follow on questions
  const parentQuestions = []
  for (const questionId in tableData.ChecklistQuestions) {
    //console.log(`questionId: ${questionId}`)
    const thisQuestion = tableData.ChecklistQuestions[questionId]
    if (!thisQuestion.parentQuestionId && !thisQuestion.parentActionId) {
      parentQuestions.push(thisQuestion)
    }
  }

  // sort parent questions by question order
  parentQuestions.sort((a, b) => parseInt(a.QuestionOrder) - parseInt(b.QuestionOrder))





  parentQuestions.forEach((question: any) => {
    // find all non repeat answers for each parent question,
    // then find all repeat answers for each parent question
    appendAnswers(question, tableData, allQuestionAnswersForCheckPeriod, checkPeriodId)

    // find all follow on questions for each question
    // sort them by question order
    // find all answers for each follow on question
    // const followUpQuestions = []
    // for (const questionId in tableData.ChecklistQuestions) {
    //   const thisQuestion = tableData.ChecklistQuestions[questionId]
    //   if (thisQuestion.parentQuestionId === question.Id) {
    //     followUpQuestions.push(thisQuestion)
    //   }
    // }

    // // sort follow up questions by question order
    // followUpQuestions.sort((a, b) => parseInt(a.QuestionOrder) - parseInt(b.QuestionOrder))


    // followUpQuestions.forEach((question: any) => {
    //   // find all non repeat answers for each parent question,
    //   // then find all repeat answers for each parent question
    //   appendAnswers(question, tableData, allQuestionAnswersForCheckPeriod, checkPeriodId)
    // })
  })


  //console.log(allQuestionAnswersForCheckPeriod)
  return allQuestionAnswersForCheckPeriod
}